import { useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Motion";
import Seo from "@/components/Seo";
import api from "@/lib/api";

export default function ArticoloDetail() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setB(r.data)).catch(() => nav("/blog")); }, [slug, nav]);

  if (!b) return <div className="min-h-screen flex items-center justify-center text-gold font-display">Caricamento…</div>;
  const paras = (b.body || "").split("\n").filter((p) => p.trim());

  return (
    <div className="pt-32 pb-28 min-h-screen">
      <Seo title={b.title} description={b.excerpt || paras[0]} image={b.cover && !b.cover.startsWith("data:") ? b.cover : undefined} type="article"
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: b.title, description: b.excerpt, image: b.cover && !b.cover.startsWith("data:") ? b.cover : undefined,
          author: { "@type": "Person", name: b.author || "Davide Bellafiore" }, publisher: { "@type": "Organization", name: "LUX AETERNA" }, articleSection: b.category, inLanguage: "it" }} />
      <article className="max-w-[760px] mx-auto px-6">
        <Reveal>
          <Link to="/blog" className="inline-flex items-center gap-2 text-[#2A1F14]/50 hover:text-gold text-sm mb-10"><ArrowLeft size={16} /> Blog</Link>
          <p className="text-[10px] uppercase tracking-[0.25em] text-gold mb-4">{b.category}</p>
          <h1 className="font-display text-4xl sm:text-5xl text-[#2A1F14] leading-tight mb-6">{b.title}</h1>
          <p className="text-[#2A1F14]/40 text-sm mb-12">{b.date} · {b.author}</p>
        </Reveal>
        {b.cover && (
          <Reveal><div className="aspect-[16/9] rounded-2xl overflow-hidden mb-12"><img src={b.cover} alt={b.title} className="w-full h-full object-cover" /></div></Reveal>
        )}
        <Reveal>
          {b.excerpt && <p className="font-display italic text-2xl text-[#2A1F14]/70 leading-relaxed mb-12">{b.excerpt}</p>}
          <div className="space-y-7">
            {paras.map((p, i) => <p key={i} className="text-[#2A1F14]/70 text-lg leading-relaxed">{p}</p>)}
          </div>
        </Reveal>
        <div className="mt-16 pt-10 border-t border-[#2A1F14]/10">
          <p className="text-[#2A1F14]/50 text-sm mb-4">Vuoi approfondire questo tema?</p>
          <Link to="/servizi" className="text-gold link-underline">Scopri i percorsi di Lux Aeterna →</Link>
        </div>
      </article>
    </div>
  );
}
